import styled from 'styled-components';
import { palette } from '../../styles/palette';

export const Footnote = styled.div`
  font-size: 0.8rem;
  color: ${palette.lightMidGrey};
  margin-top: 30px;
`;
